<template lang="pug">
.filter-group(:class="{active}")
  .filter-group__title(
    tabindex="0",
    role="button",
    @click="active = !active") {{ filterGroup.name }}
  TransitionExpand
    .filter-group__options(v-show	="active")
      .filter-group__options-inner
        SearchFiltersItem(
          v-for="filter in filterGroup.filters",
          :key="filter.id",
          :filter="filter",
          :groupID="filterGroup.id")
</template>

<script>
import TransitionExpand from "../transitions/TransitionExpand";
import SearchFiltersItem from "./SearchFiltersItem";

export default {
  name: "SearchFiltersGroup",
  props: ["filterGroup"],
  components: {
    TransitionExpand,
    SearchFiltersItem,
  },
  data() {
    return {
      active: true,
    };
  },
};
</script>


<style lang="scss" scoped>
.filter-group {
  display: flex;
  flex-direction: column;
	&:first-child {
		.filter-group__title {
			border-top: 1px solid $lightGray;
		}
	}
  &:last-of-type {
    padding-bottom: 0.5rem;
    margin-bottom: 1.25rem;
  }

  &__title {
		position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0 1rem;
		border-bottom: 1px solid $lightGray;
    color: $black;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.3;
    cursor: pointer;
    &::before,
		&::after {
      content: '';
			position: absolute;
			width: 0.625rem;
			height: 0.125rem;
			background-color: $black;
			transition: 0.25s ease;
    }
		&::before {
			right: 0;
		}
		&::after {
			right: 0;
			transform: rotate(90deg);
		}
    &:hover {
			color: $primaryPurple;
      &::before,
			&::after {
				background-color: $primaryPurple;
			}
    }
    .active & {
      &::after {
        transform: rotate(0deg);
      }
    }
  }

  &__options {
    display: flex;
    flex-direction: column;
		border-bottom: 1px solid $lightGray;
  }

  &__options-inner {
    display: flex;
    flex-direction: column;
    padding: 0.875rem 0 0.875rem;
  }
}
</style>